import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

export default class extends BridgeComponent {
  static component = "menu"

  connect() {
    super.connect()
    const items = this.#parseItems(this.element)
    this.send("connect", { items }, (message) => {
      if (message.data?.url) Turbo.visit(message.data.url)
    })
  }

  #parseItems(parent) {
    return Array.from(parent.children)
      .filter(el => el.dataset.bridgeRole)
      .map(el => {
        if (el.dataset.bridgeRole === "group") {
          return {
            type: "group",
            title: el.dataset.bridgeTitle || "",
            iosImage: el.dataset.bridgeIosImage || "",
            androidImage: el.dataset.bridgeAndroidImage || "",
            children: this.#parseItems(el)
          }
        }
        return {
          type: "item",
          title: el.dataset.bridgeTitle || "",
          url: el.href || "",
          iosImage: el.dataset.bridgeIosImage || "",
          androidImage: el.dataset.bridgeAndroidImage || ""
        }
      })
  }
}
